import { Pipe, PipeTransform } from "@angular/core";
import { orderBy } from 'lodash';
@Pipe({ name: 'sortByDateAndUndefined' })
export class SortByDateAndUndefinedPipe implements PipeTransform {

  transform(array: any[], order = '', prop: string): any[] {
    if (!Array.isArray(array) || !prop) {
        return array;
    }
    const filteredArray = array.filter(item => item.hasOwnProperty(prop) && item[prop]);
    const sortedArray = filteredArray.sort((a, b) => {
        const aValue = a[prop];
        const bValue = b[prop];
        if (order === 'asc') {
          return aValue > bValue ? 1 : (aValue < bValue ? -1 : 0);
        } else {
          return bValue > aValue ? 1 : (bValue < aValue ? -1 : 0);
        }
    });
    const undefinedPropItems = array.filter(item => !item.hasOwnProperty(prop) || !item[prop]);
    sortedArray.push(...undefinedPropItems);
    return sortedArray;
  }
}